import {
  GET_AUTOSUGGESTION_RESULTS,
  GET_AUTOSUGGESTION_RESULTS_SUCCESS,
  GET_AUTOSUGGESTION_RESULTS_ERROR,
  CLEAR_AUTOSUGGESTION_RESULTS,
  GET_TOOLBARCONFIG_REQUEST_SUCCESS,
  GET_TOOLBARCONFIG_REQUEST_ERROR,
  GET_TOOLBARCONFIG_REQUEST,
} from "./action-types";

export const initialState = {
  autoSuggestions: {
    isFetching: false,
    hasFetched: false,
    suggestions: {},
    query: "",
    error: null,
  },
  config: {
    isFetching: false,
    hasFetched: false,
  },
};

const reducer = function (state, action) {
  switch (action.type) {
    case GET_TOOLBARCONFIG_REQUEST: {
      return {
        ...state,
        config: {
          ...state.config,
          isFetching: true,
        },
      };
    }
    case GET_TOOLBARCONFIG_REQUEST_SUCCESS: {
      return {
        ...state,
        config: {
          ...action.payload,
          isFetching: false,
          hasFetched: true,
        },
      };
    }
    case GET_TOOLBARCONFIG_REQUEST_ERROR: {
      return {
        ...state,
        config: {
          isFetching: false,
          hasFetched: true,
          error: action.error,
        },
      };
    }
    case GET_AUTOSUGGESTION_RESULTS: {
      // If we're searching for a new term, let's reset our search results
      const suggestions =
        state.autoSuggestions.query?.q === action.payload.q
          ? state.autoSuggestions.suggestions
          : {};
      return {
        ...state,
        autoSuggestions: {
          ...state.autoSuggestions,
          suggestions,
          query: action.payload,
          isFetching: true,
          hasFetched: false,
        },
      };
    }
    case GET_AUTOSUGGESTION_RESULTS_SUCCESS: {
      let suggestions = {};
      for (let i = 0; i < action.payload.length; i++) {
        suggestions[action.payload[i].suggestionType] =
          action.payload[i].suggestions;
      }
      suggestions = processSuggestions(suggestions);
      return {
        ...state,
        autoSuggestions: {
          ...state.autoSuggestions,
          suggestions,
          isFetching: false,
          hasFetched: true,
        },
      };
    }
    case GET_AUTOSUGGESTION_RESULTS_ERROR: {
      return {
        ...state,
        autoSuggestions: {
          suggestions: {},
          error: action.error,
          isFetching: false,
          hasFetched: true,
        },
      };
    }
    case CLEAR_AUTOSUGGESTION_RESULTS: {
      return {
        ...state,
        autoSuggestions: initialState.autoSuggestions,
      };
    }
    default:
      return state;
  }
};

const processSuggestions = (response) => {
  const gotoTitle = "Go to";
  const autoSuggestionTitle = "title";
  const autoSuggestionTerm = "term";
  const searchForTitile = "Search for";
  const suggestionListLength = 5;

  if (!response?.title) {
    return; // No suggestions to process
  }
  response.title =
    response.title && response.title.length > suggestionListLength
      ? response.title.splice(0, suggestionListLength)
      : response.title;
  response.term =
    response.term && response.term.length > suggestionListLength
      ? response.term.splice(0, suggestionListLength)
      : response.term;

  return [
    {
      title: gotoTitle,
      autoSuggestionSection: autoSuggestionTitle,
      items: response.title
        ? response.title.filter((item) => item.completedPhrase)
        : [],
    },
    {
      title: searchForTitile,
      autoSuggestionSection: autoSuggestionTerm,
      items: response.term
        ? response.term.filter((item) => item.completedPhrase)
        : [],
    },
  ].filter((section) => section.items.length > 0);
};

export { reducer };
